import React from "react";
import paytomLogo from "../../assests/images/logo.png";
import klikpayLogo from "../../assests/images/klikpaylogo.png";
import QRBonPayLogo from "../../assests/images/banqo.jpg";
import leopaylogo from "../../assests/images/leopay.jpg";
import "./Header.css";
import Avatar from "react-avatar";
import { FaSearchDollar } from "react-icons/fa";
import TooltipLite from "react-tooltip-lite";
// import { IoIosWallet } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";

import {
  removeUserSession,
  dangerColor,
  klikpayTitle,
  formatNumberForIndia,
  copyTextToClipboard,
} from "../../utils/comman/Common";

import { useNavigate } from "react-router-dom";
import axiosinstances from "../../Helper/useAxios";
import { toast } from "react-toastify";
import { getBalance } from "../../redux/Getbalance/action";
import axios from "axios";
import { getLocationAndip } from "../../redux/IpAndLocation/action";
import { getConfigdetails } from "../../redux/config/action";
import { LEOPAY_TITLE_NAME, serviceId } from "../../utils/Constant";
const service = "upi-web-config";

const AGENTPAY_URL = "AGENTPAY_URL";
const Header = () => {
  const dispatch = useDispatch();
  const balance = useSelector(
    (state) => state?.getbalanceresucer?.getbalancelist
  );
  const [agentUrlValue, setAgentUrlValue] = useState("");
  const title = process.env.REACT_APP_TITLE;
  const userIp = useSelector((state) => state.userIpAddReducer.ip);
  const [axiosInstance] = axiosinstances(userIp);
  const logo =
    title === "KlikPay Merchant Portal"
      ? klikpayLogo
      : title === "QRBonPay Merchant Portal"
      ? QRBonPayLogo
      : title == LEOPAY_TITLE_NAME
      ? leopaylogo
      : paytomLogo;
  const navigate = useNavigate();
  const retailerName = sessionStorage.getItem("rname");
  const [balanceLoader, setBalanceLoader] = useState(false);

  const mid = JSON.parse(sessionStorage.getItem("mid"));

  const sessionId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.sessionId
  );
  const reqId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.requestId
  );
  // const reqIdaaa = useSelector((state) => console.log(state));
  const isAgent = useSelector(
    (state) => state.authReducer.auth?.data?.merchant?.isAgent
  );
  console.log("isAgent", isAgent);
  const e = JSON.parse(sessionStorage.getItem("token"));

  const headers = {
    Authorization: `Bearer ${e}`,
    "client-id": sessionId,
    "request-id": reqId,
  };

  let name = JSON.parse(sessionStorage.getItem("name"));
  const fetchIP = async () => {
    try {
      const response = await axios.get("https://api.ipify.org?format=json");
      dispatch(getLocationAndip({ ip: response.data.ip }));
    } catch (error) {
      console.error("Error fetching IP:", error);
    }
  };
  const fetchConfigDetails = async () => {
    let url = `/api/v1/upi/config/get/${serviceId}`;
    console.log("fetchConfigDetails url", url);
    await axiosInstance
      .get(url, {
        headers,
      })
      .then((res) => {
        dispatch(getConfigdetails(res.data));
      })
      .catch((err) => {
        toast.error("Something went wrong");
      });
  };
  useEffect(() => {
    fetchIP();
    fetchConfigDetails();
  }, []);
  const showAvtar = () => {
    return <Avatar name={name} size={36} round="18px" />;
  };
  const myAvtar = React.useMemo(() => showAvtar(), [name]);
  const showBal = (balance) => {
    if (
      balance?.balance !== undefined &&
      balance?.balance >= 0 &&
      !balanceLoader
    ) {
      return <>{formatNumberForIndia(balance?.balance)}</>;
    } else if (balance?.balance < 0 && !balanceLoader) {
      return <span style={{ color: dangerColor }}>{"NA"}</span>;
    } else if (balance?.errCode !== undefined && !balanceLoader) {
      return <span style={{ color: dangerColor }}>{"NA"}</span>;
    } else {
      return <FaSearchDollar size={15} />;
    }
  };
  const payInType = "payin";
  const payoutType = "payout";
  const showTotalWalletBalance = (bal, type) => {
    return (
      Array.isArray(bal) &&
      bal.map((balance, index) => {
        if (balance.type == type) {
          return showBal(balance);
        }
      })
    );
  };
  const fetchBalance = async () => {
    const data = { id: mid, headers: headers };
    dispatch(getBalance(data));
  };
  const fetchConfigdata = async (service, serviceId) => {
    let url = `/api/v1/upi/config/get/${service}/${serviceId}`;

    try {
      const res = await axiosInstance.get(url, { headers });

      if (res.status === 200 && res?.data !== undefined) {
        const value = res.data?.value;

        setAgentUrlValue(value);
      }
    } catch {
      toast.warn(
        `unable to fetch config of service ${service} serviceId ${serviceId}`
      );
    }
  };

  useEffect(() => {
    fetchBalance();
    fetchConfigdata(service, AGENTPAY_URL);
    return () => {};
  }, []);

  const logOut = () => {
    alert("Are you Sure For Logout");
    removeUserSession();
    navigate("/", { replace: true });
    // window.location.reload();
  };
  const changePassword = () => {
    navigate("/change-password");
  };
  const toProfile = () => {
    navigate("/profile");
  };

  const resellerMap = agentUrlValue.split(",").reduce((acc, item) => {
    const [key, url] = item.split("$");
    acc[key.toLowerCase()] = url; // store lowercase keys
    return acc;
  }, {});

  const oldcopyAgentLink = () => {
    const title = document.title;
    console.log("tital123", title);

    if (title === "Paytom Merchant Portal") {
      const agentUrl = `https://agentpay.paytom.online/${mid}`;

      copyTextToClipboard(agentUrl, toast);
    } else if (title === "KlikPay Merchant Portal") {
      const agentUrl = `https://agentpay.klikpay.me/${mid}`;
      copyTextToClipboard(agentUrl, toast);
    } else if (title === "QRBonPay Merchant Portal") {
      //https://agentpay.qrbonpay.com
      const agentUrl = `https://agentpay.qrbonpay.com/${mid}`;
      copyTextToClipboard(agentUrl, toast);
    } else if (title === "Merchant Portal") {
      const agentUrl = `https://agentpay.leopay.live/${mid}`;
      copyTextToClipboard(agentUrl, toast);
    }
  };
  const copyAgentLink = (e, data) => {
    e.preventDefault();
    e.stopPropagation();

    const title = document.title.toLowerCase(); // lowercase title
    let agentUrl = "";
    // lowercase reseller
    if (agentUrlValue.length > 0) {
      const reseller = data?.reseller?.toLowerCase();
      const baseUrl = resellerMap[reseller] || resellerMap["default"]; // fallback
      agentUrl = `${baseUrl}/${mid}`;
    } else {
      oldcopyAgentLink();
    }

    if (agentUrl) {
      //console.log("agentUrl", agentUrl);
      copyTextToClipboard(agentUrl, toast);
    }
  };
  return (
    <div className="header">
      <div className="container-fluid">
        <div className="row">
          <div className="mobile-views col-2 col-md-4">
            <div className="logo">
              <a href="/dashboard">
                {/* {title !== LEOPAY_TITLE_NAME && ( */}
                <img
                  style={{ borderRadius: "5px", backgroundColor: "#333333" }}
                  src={logo}
                  alt="FinXpay"
                  className="d-none d-md-block"
                />
                {/* )} */}
              </a>

              <h3>{"Merchant Portal"}</h3>
            </div>
          </div>

          <div className={`col-10 col-md-8 header-profiles`}>
            <div className="profile">
              <div class="dropdown">
                <button
                  class="dropdown-toggle"
                  type="button"
                  id="prolist"
                  data-toggle="dropdown"
                  aria-expanded="false"
                >
                  {myAvtar}
                </button>
                <ul
                  class="dropdown-menu profiledropdown"
                  aria-labelledby="prolist"
                >
                  {/* <li>
                      <button type="button" class="ta" onClick={taLoadRequest}>
                        TA Load Request
                      </button>
                    </li> */}

                  <li class="last">
                    <button type="button" class="logout" onClick={toProfile}>
                      Profile
                    </button>
                  </li>
                  {isAgent && (
                    <li class="last">
                      <button
                        type="button"
                        class="logout"
                        onClick={copyAgentLink}
                      >
                        Agent link
                      </button>
                    </li>
                  )}

                  <li class="last">
                    <button
                      type="button"
                      class="logout"
                      onClick={changePassword}
                    >
                      Change Password
                    </button>
                  </li>
                  <li class="last">
                    <button type="button" class="logout" onClick={logOut}>
                      Logout
                    </button>
                  </li>
                </ul>
              </div>

              <p>
                <TooltipLite
                  content={
                    <div className="custom-tooltip-content">
                      Pay-in balance:{" "}
                      {showTotalWalletBalance(balance, payInType)} <br />
                      Pay-out balance:{" "}
                      {showTotalWalletBalance(balance, payoutType)}
                    </div>
                  }
                >
                  <span>
                    Hi, {name} ₹ {showTotalWalletBalance(balance, payInType)}
                  </span>
                </TooltipLite>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
